import { BUSINESS_SECTION_TYPE_MLE, MLE_CREATE_FORM_NAME } from 'components/Onboarding/Mle/BusinessTab/contants';
import {
    FETCH_MERCHANT_LEGAL_ENTITY_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS,
    EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS,
    EDIT_MERCHANT_LEGAL_ENTITY_REQUEST,
    EDIT_MERCHANT_LEGAL_ENTITY_FAILURE,
    CREATE_MERCHANT_LEGAL_ENTITY_FAILURE,
    CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS,
    CREATE_MERCHANT_LEGAL_ENTITY_REQUEST,
    MERCHANT_LEGAL_ENTITY_FORM_RESET,
    SET_STATIC_MERCHANT_LEGAL_ENTITY,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST,
    FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS,
    FETCH_BASIC_FORM_DATA_SUCCESS_V1,
    FETCH_BASIC_FORM_DATA_FAILURE_V1,
    SAVE_AND_CONTINUE_SUCCESS_V1,
    SAVE_AND_CONTINUE_FAILED_V1,
    RESET_SUCCESS_KEY,
    RESET_FORM_DATA_MLE,
    FETCH_MLE_FORM_IN_PROCESS_SUCCESS,
    FETCH_MLE_FORM_IN_PROCESS_ERROR,
    SUBMIT_SUCCESS_DATA_MLE,
    SUBMIT_FAILURE_DATA_MLE,
    REDIRECT_KEY_MLE,
    CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS
} from './merchantLegalEntity.constants';

import MerchantLegalEntityModal from './model/merchantLegalEntityList';
import moment from 'moment';
import { UBO_CREATE_FORM_NAME, UBO_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';
import { SUBMITTED_KEY } from 'components/Onboarding/Mle/mle.constants';
import { MERCHANT_TIMELINE_STATUS, UBODETAILS } from '../constants';
import MLEDraftData from './model/mleDraftData';

export const initialState = {
    formData: {},
    formEvents: {},
    uniqueIdentifier: '',
    tableData: [],
    pagination: {},
    error: {},
    editData: {},
    createData: {},
    relationshipManagerMap: {},
    isLoading: false,
    isSuccess: false,
    listingDraftData: {tableData: []},
    listingError: '',
    redirect: '',
    basicFormData: {}
};

const makeEditData = data => {

    if (!data || !data?.[BUSINESS_SECTION_TYPE_MLE]) {
        return;
    }
    try {
        const editData = {
            forms: [{
              sections: [
                {
                  type: BUSINESS_SECTION_TYPE_MLE,
                  data: {
                    ...data[BUSINESS_SECTION_TYPE_MLE]
                  },
                },
                {
                  type: UBO_SECTION_TYPE,
                  data: {
                    ...data[UBO_SECTION_TYPE]
                  },
                },
              ],
            }],
            createdAt: data?.createdAt,
            updatedAt: data?.updatedAt,
            checkoutMigrated : data.checkoutMigrated || false
          };
        //   console.log("edit data", editData);
        // delete editData.address;

        return editData;
    } catch(e) {
        console.log("make edit data...", e);
    }
};

const getFilledStatus = (data) => {
    // form filled status
    let filledStatus = {};
    if (data?.forms?.[0]?.sections?.length) {


        let businessDetailLen = data?.forms?.[0]?.sections?.filter(items => (items.type === BUSINESS_SECTION_TYPE_MLE))?.length;
        filledStatus[`${MLE_CREATE_FORM_NAME}status`] = businessDetailLen > 0 ? MERCHANT_TIMELINE_STATUS.Complete : MERCHANT_TIMELINE_STATUS.Pending;
        let uboDetailLen = data?.forms?.[0]?.sections?.filter(items => (items.type === UBO_SECTION_TYPE))?.length;
        filledStatus[`${UBO_CREATE_FORM_NAME}status`] = uboDetailLen > 0 ? MERCHANT_TIMELINE_STATUS.Complete : (businessDetailLen > 0) ? MERCHANT_TIMELINE_STATUS.Open : MERCHANT_TIMELINE_STATUS.Pending;

    }
    return filledStatus;
}

export const merchantLegalEntityReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BASIC_FORM_DATA_SUCCESS_V1: {
            console.log("called fetch basic form data reducer", action);
            return {
                ...state,
                basicFormData: {
                    ...state.basicFormData,
                    ...action.payload.data || action.payload
                },
                error: {}
            };
        }
        case FETCH_BASIC_FORM_DATA_FAILURE_V1: {
            console.log('action payload', action.payload);
            return {
                ...state,
                basicFormData: {
                    ...state.basicFormData,
                    error: {
                        basicFormData: action.payload.errorMessage || 'Please try again',
                    },
                },
            };
        }
        case FETCH_MERCHANT_LEGAL_ENTITY_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: {},
            };

        case FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS:
            const merchantLegalEntityData = new MerchantLegalEntityModal(
                action.payload,
                state.relationshipManagerMap
            );

            return {
                ...state,
                ...merchantLegalEntityData,
                isLoading: false,
                error: {},
            };

        case FETCH_MERCHANT_LEGAL_ENTITY_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload?.error,
            };
        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST:
            return {
                ...state,
                editData: {},
                error: {},
            };

        case REDIRECT_KEY_MLE:

            return {
                ...state,
                redirect: ''
            }

        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS:

            const editData = makeEditData(action.payload);

            const uniqueIdentifier = action.payload.entityCode;

            const filledStatus = getFilledStatus(editData);

            const redirect = `/mle-onboarding/view/${UBODETAILS}/${uniqueIdentifier}`
            return {
                ...state,
                editData,
                formData: {
                    ...editData
                },
                formEvents: {
                    ...filledStatus
                },
                uniqueIdentifier,
                redirect,
                checkoutMigrated: action.payload?.checkoutMigrated,
                error: {},
            };
        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload,
                redirect: 'error'
            };
        case CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS:
            return {
                ...state,
                editData: {},
                error: {},
                merchantLegalEntityData :{},
            };
        //fetch Pincode details from the API for MLE details
        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST:
            return {
                ...state,
                editData: {},
                error: {},
            };

        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS:
            const tempeditData = makeEditData(action.payload);
            return {
                ...state,
                tempeditData,
                error: {},
            };
        case FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE:
            return {
                ...state,
                error: action.payload,
            };



        case CREATE_MERCHANT_LEGAL_ENTITY_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
            };

        case CREATE_MERCHANT_LEGAL_ENTITY_FAILURE:
            return {
                ...state,
                isSuccess: false,
                isLoading: false,
                error: { ...action.payload.error },
            };
        case CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
            };
        case EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSuccess: true,
            };

        case EDIT_MERCHANT_LEGAL_ENTITY_REQUEST:
            return {
                ...state,
                isLoading: true,
                isSuccess: false,
            };

        case EDIT_MERCHANT_LEGAL_ENTITY_FAILURE:
            return {
                ...state,
                isLoading: false,
                isSuccess: false,
                error: {
                    ...action.payload.error,
                },
            };

        case MERCHANT_LEGAL_ENTITY_FORM_RESET:
            return {
                ...state,
                editData: initialState.editData,
                createData: initialState.createData,
                isSuccess: false,
            };
        case SET_STATIC_MERCHANT_LEGAL_ENTITY: {
            const relationshipManagerMap = {};
            const relationshipManagerInfoResponse = action.payload.relationshipManagerInfoResponse || [];
            relationshipManagerInfoResponse.forEach(item => {
                relationshipManagerMap[item.email] = item.name;
            });
            return {
                ...state,
                relationshipManagerMap,
            };
        }
        case SAVE_AND_CONTINUE_SUCCESS_V1: {

            let isSubmit = {};
            if (action.sectionType)
                isSubmit[action.sectionType] = SUBMITTED_KEY;
            let isFormSubmitted = action?.payload?.isSubmit; // submit form call
            let uniqueIdentifier = action?.payload?.forms?.[0]?.uniqueIdentifier;

            const filledStatus = getFilledStatus(action.payload);

            return {
                ...state,
                formData: {
                    ...state.formData,
                    ...action?.payload
                },
                formEvents: {
                    ...isSubmit,
                    ...filledStatus,
                    isFormSubmitted
                },
                uniqueIdentifier

            }
        }
        case SUBMIT_SUCCESS_DATA_MLE:

            let isFormSubmitted = action?.payload?.isSubmit; // submit form call
            return {
                ...state,
                formEvents: {
                    ...state.formEvents,
                    isFormSubmitted
                }
            }
        case SUBMIT_FAILURE_DATA_MLE:
            return {
                ...state,
                formEvents: {
                    ...state.formEvents,
                    isFormSubmitted: false
                },
                errors: {
                    ...state.error,
                    formDataError: action?.payload?.errorMessage || ""
                }
            }
        case SAVE_AND_CONTINUE_FAILED_V1:
            return {
                ...state,
                errors: {
                    ...state.error,
                    formDataError: action?.payload?.errorMessage || ""
                }
            }
        case RESET_SUCCESS_KEY: {
            console.log("reset success key", action);
            let isSubmit = {};
            isSubmit[action?.payload?.sectionType] = '';
            return {
                ...state,
                formEvents: {
                    ...state.formEvents,
                    ...isSubmit,
                    isFormSubmitted: false
                }
            }
        }
        case RESET_FORM_DATA_MLE: {
            console.log("reducer called", RESET_FORM_DATA_MLE);
            return {
                ...state,
                formData: initialState.formData,
                formEvents: initialState.formEvents,
                uniqueIdentifier: initialState.uniqueIdentifier
            }
        }

        case FETCH_MLE_FORM_IN_PROCESS_SUCCESS:
            console.log("action payload", action.payload);
            const listing = new MLEDraftData(action.payload);
            return {
                ...state,
                listingDraftData: listing,
                listingError: ''
            }
        case FETCH_MLE_FORM_IN_PROCESS_ERROR:
            return {
                ...state,
                listingError: action?.payload?.errorMessage || ''
            }
        default:
            return state;
    }
};
